import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TrustSignals from "@/components/TrustSignals";
import ServicesGrid from "@/components/ServicesGrid";
import CarrierLogos from "@/components/CarrierLogos";
import CityGrid from "@/components/CityGrid";
import Testimonials from "@/components/Testimonials";
import FAQSection from "@/components/FAQSection";
import LeadMagnet from "@/components/LeadMagnet";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";
import PrivacyPromise from "@/components/PrivacyPromise";
import SEOHead from "@/components/SEOHead";
import { homepageFaqs } from "@/components/FAQSection";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: homepageFaqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const homepageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "InsuranceAgency",
      name: "Mom & Pop Insurance Shop",
      description: "Arizona's independent insurance brokerage. Compare 30+ carriers for auto, home, commercial, health, life, and group benefits insurance.",
      url: "https://momandpopinsurance.com",
      telephone: "+1-602-282-0383",
      email: "info@momandpopinsuranceshop.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "2233 N 7th Street",
        addressLocality: "Phoenix",
        addressRegion: "AZ",
        postalCode: "85006",
        addressCountry: "US",
      },
      geo: { "@type": "GeoCoordinates", latitude: 33.4664, longitude: -112.0654 },
      areaServed: [
        { "@type": "State", name: "Arizona" },
        { "@type": "State", name: "Texas" },
        { "@type": "State", name: "North Carolina" },
        { "@type": "State", name: "Illinois" },
        { "@type": "State", name: "Arkansas" },
        { "@type": "State", name: "California" },
      ],
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "09:00",
          closes: "18:00",
        },
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Saturday"],
          opens: "09:00",
          closes: "13:00",
        },
      ],
      sameAs: [
        "https://www.facebook.com/momandpopinsuranceshop",
        "https://www.instagram.com/momandpopinsuranceshop",
        "https://www.linkedin.com/company/momandpopinsuranceshop",
        "https://www.google.com/maps/place/Mom+%26+Pop+Insurance+Shop+LLC/@33.485292,-112.0331675,17z",
      ],
      hasMap: "https://www.google.com/maps?q=2233+N+7th+Street,+Phoenix,+AZ+85006",
    },
    {
      "@type": "LocalBusiness",
      name: "Mom & Pop Insurance Shop",
      image: "https://momandpopinsurance.com/og-image.png",
      priceRange: "Free quotes",
      telephone: "+1-602-282-0383",
      address: {
        "@type": "PostalAddress",
        streetAddress: "2233 N 7th Street",
        addressLocality: "Phoenix",
        addressRegion: "AZ",
        postalCode: "85006",
      },
    },
  ],
};

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Mom & Pop Insurance Shop | AZ Independent Broker"
        description="Arizona's independent insurance brokerage. Compare 30+ carriers for auto, home, business, health & life insurance. Free quotes from Phoenix-based brokers."
        canonical="https://momandpopinsurance.com/"
      />
      <Header />
      <main>
        <HeroSection />
        <TrustSignals />
        <CarrierLogos />
        <ServicesGrid />
        <section className="py-16 md:py-20">
          <div className="container max-w-2xl">
            <LeadMagnet
              title="Free: Arizona Insurance Cost Guide"
              description="Compare average insurance costs across Arizona. Auto, home, commercial, health — see what you should be paying."
              buttonText="Download Free Guide"
            />
          </div>
        </section>
        <Testimonials />
        <CityGrid />
        <FAQSection />
        <PrivacyPromise />
      </main>
      <Footer />
      <FloatingCTA />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </div>
  );
};

export default Index;
